import React from 'react';
import { Package } from 'types/package';
import history from 'services/history';
import DataGridList from 'components/data-grid/DataGridList';
import { packageTableTemplate } from '../../template/packageTableTemplate';

type PackageListTableProps = {
  packages: Package[];
};

const PackageListTable: React.FC<PackageListTableProps> = ({ packages }) => {
  return (
    <DataGridList
      template={packageTableTemplate}
      rows={packages}
      getRowId={row => row.id}
      onRowClick={row => history.push(`/packages/${row.id}`)}
      fileName="pacotes"
      sheetName="Pacotes"
    />
  );
};

export default PackageListTable;
